import { create } from 'zustand';

export const CURRENT_INVESTIGATION_STORAGE_KEY = 'currentInvestigation';
export const CURRENT_INVESTIGATION_NAME_STORAGE_KEY =
  'currentInvestigationName';

/**
 * @typedef {Object} InvestigationStore
 * @property {string | null} currentInvestigation
 * @property {string | null} currentInvestigationName
 *
 * functions
 * @property {(id: String, name: String) => void} setCurrentInvestigation
 * @property {() => void} removeCurrentInvestigation
 */

const initState = {
  currentInvestigation:
    localStorage.getItem(CURRENT_INVESTIGATION_STORAGE_KEY) || null,
  currentInvestigationName:
    localStorage.getItem(CURRENT_INVESTIGATION_NAME_STORAGE_KEY) || null,
};

/**
 * Store for the Tracer
 * @type {import('zustand').UseBoundStore<import('zustand').StoreApi<InvestigationStore>>}
 * */
const useInvestigationStore = create((set) => ({
  ...initState,

  setCurrentInvestigation: (id, name) => {
    localStorage.setItem(CURRENT_INVESTIGATION_STORAGE_KEY, id);
    localStorage.setItem(CURRENT_INVESTIGATION_NAME_STORAGE_KEY, name);
    set({ currentInvestigation: id, currentInvestigationName: name });
  },

  removeCurrentInvestigation: () => {
    localStorage.removeItem(CURRENT_INVESTIGATION_STORAGE_KEY);
    localStorage.removeItem(CURRENT_INVESTIGATION_NAME_STORAGE_KEY);
    set({ currentInvestigation: null, currentInvestigationName: null });
  },
}));
export default useInvestigationStore;
